module.exports = __webpack_public_path__ + "static/media/logo-dekton.a0f44023.svg";